import { Link } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import { Logo, NAV_LINKS } from "./Navbar";
import { contactItems, socialLinks } from "./contactInfo";

export const Footer = () => {
  const { settings: s } = useSite();
  const socials = socialLinks(s);
  return (
    <footer className="bg-[#0B1F44] text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2 space-y-5">
          <Logo light />
          <p className="text-sm max-w-md leading-relaxed text-slate-400">{s?.hero_subtitle}</p>
          {socials.length > 0 && (
            <div className="flex gap-3">
              {socials.map(([u, Icon, k]) => (
                <a key={k} href={u} target="_blank" rel="noreferrer" className="h-10 w-10 grid place-items-center rounded-full bg-white/10 hover:bg-blue-600 transition-colors" data-testid={`footer-social-${k}`}><Icon className="h-4 w-4" /></a>
              ))}
            </div>
          )}
        </div>
        <div>
          <h4 className="font-display text-white font-semibold mb-4">Explore</h4>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="space-y-3 text-sm">
          <h4 className="font-display text-white font-semibold mb-4">Get in touch</h4>
          {contactItems(s).map(([Icon, l, v, href]) => (
            <p key={l} className="flex gap-2 break-words" data-testid={`footer-contact-${l.toLowerCase().replace(/\s+/g, "-")}`}>
              <Icon className="h-4 w-4 mt-0.5 shrink-0 text-blue-400" />
              {href ? <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="hover:text-white break-all">{v}</a> : <span className="whitespace-pre-line">{v}</span>}
            </p>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-slate-400">
          <p>© {new Date().getFullYear()} {s?.association_name || "Thanjavur District Badminton Association"}. All rights reserved.</p>
          <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
